module.exports = __webpack_public_path__ + "src/assets/textureAtlas.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/textureAtlas.png
// module id = ./src/assets/textureAtlas.png
// module chunks = 0